import { render, staticRenderFns } from "./ArrivalForm.vue?vue&type=template&id=0286bf1f&scoped=true&"
import script from "./ArrivalForm.vue?vue&type=script&lang=js&"
export * from "./ArrivalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0286bf1f",
  null
  
)

export default component.exports